import { render } from "./MarketReport.vue?vue&type=template&id=5eac6aec&scoped=true"
import script from "./MarketReport.vue?vue&type=script&lang=js"
export * from "./MarketReport.vue?vue&type=script&lang=js"

import "./MarketReport.vue?vue&type=style&index=0&id=5eac6aec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eac6aec"]])

export default __exports__